<template>
  <div class="p-page-wrapper p-projects">
    <div class="p-toolbar flex justify-center">
      <p-date-time-picker
        v-model="eventlogDateFrom"
        :date-only="true"
        prepend-icon="mdi-clock-outline"
        date-class="p-input-implicit"
        time-class="p-input-implicit"
        hide-details="auto"
        class="flex-grow-0"
        tabindex="1"
        dense
        implicit
        center
        @change="onEventlogDateFromChange"
      ></p-date-time-picker>
      <span class="mr-10 mt-2 pt-1">&mdash;</span>
      <p-date-time-picker
            v-model="eventlogDateTo"
            :date-only="true"
            prepend-icon="mdi-clock-outline"
            date-class="p-input-implicit"
            time-class="p-input-implicit"
            hide-details="auto"
            class="flex-grow-0"
            tabindex="1"
            dense
            implicit
            center
            @change="onEventlogDateToChange"
          ></p-date-time-picker>
      <div class="refresh-btn-wrapper">
        <p-btn-icon
          color="primary"
          icon="mdi-refresh"
          :tooltip="$t('eventlog.refreshBtn')"
          @click="onRefreshClick"
        ></p-btn-icon>
      </div>
    </div>
    <v-divider></v-divider>
    <v-data-table
      :headers="tableHeaders"
      :items="eventlogComputed"
      :options.sync="tableOptions"
      :server-items-length="eventlogTotalCount"
      class="p-no-borders"
      disable-filtering
      hide-default-footer
      @page-count="pageCount = $event"
      @update:options="reloadEventlog"
    >
      <template v-slot:[`item.userId`]="{ item }">
        <div class="py-6">
          <p-user-item
            :value="userById(item.userId) || {}"
            avatar-class="mr-2"
            avatar-only
          ></p-user-item>
        </div>
      </template>
      <template v-slot:[`item.fields`]="{ item }">
        <ul>
          <li v-for="field in item.fields" :key="`field-${field}`" class="">
            {{ field }}
          </li>
        </ul>
      </template>
      <template v-slot:[`item.time`]="{ item }">
        <span class="p-projects__date-string">{{ getTime(item.time) }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="p-table-row-actions">
          <PBtnIcon v-if="item.action !== 'Delete'" type="view" @click="goToEntity(item)"></PBtnIcon>
        </div>
      </template>
    </v-data-table>

    <v-pagination
      v-model="tablePage"
      :length="pageCount"
      :total-visible="15"
      class="mt-5"
    ></v-pagination>
  </div>
</template>


<script>
import PUserItem from '@/components/PUserItem'
import PDateTimePicker from '@/components/PDateTimePicker'
import PBtnIcon from '@/components/PBtnIcon'

import pageMixin from '@/mixins/page.mixin'
import userSettingsMixin from '@/mixins/userSettings.mixin'

import { mapActions, mapGetters } from 'vuex'

import moment from 'moment'

import { routeNameByParam } from '@/constants'

export default {
  components: {
    PDateTimePicker,
    PUserItem,
    PBtnIcon
  },


  mixins: [
    pageMixin,
    userSettingsMixin
  ],


  data () {
    return {
      eventlogDateFrom: null,
      eventlogDateTo: null,
      tableOptions: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: []
      },
      pageCount: 0,
      eventlogLoaded: false,
      tablePage: 1
    }
  },

  watch: {
    tablePage (newTablePage) {
      this.tableOptions.page = newTablePage
      this.reloadEventlog()
    }
  },

  computed: {
    ...mapGetters('eventlog', ['eventlog', 'eventlogTotalCount']),
    ...mapGetters('user', ['currentUserId', 'userById', 'users']),

    eventlogComputed () {
      return this.eventlog.map(eventlogItem => {
        return {
          ...eventlogItem
        }
      })
    },

    tableHeaders () {
      return [
        { text: this.$t('eventlog.table.param'), value: 'param' },
        { text: this.$t('eventlog.table.text'), value: 'text' },
        { text: this.$t('eventlog.table.action'), value: 'action' },
        { text: this.$t('eventlog.table.fields'), value: 'fields' },
        { text: this.$t('eventlog.table.time'), value: 'time' },
        { text: this.$t('eventlog.table.user'), value: 'userId' },
        { text: '', value: 'actions', align: 'end', sortable: false, filterable: false }
      ]
    }
  },


  methods: {
    ...mapActions('eventlog', ['loadEventlog']),
    ...mapActions('user', ['loadUsers', 'loadUserById']),

    goToEntity (item) {
      this.$router.push({
        name: routeNameByParam[item.param],
        params: { goto: item.text }
      })
    },

    onRefreshClick () {
      console.info('onRefreshClick ----------->')
      this.onEventlogDateChange()
    },

    getDate (time) {
      const date = new Date(time)
      return date ? moment(date).format('YYYY-MM-DD') : ''
    },

    getTime (time) {
      const date = new Date(time)
      return date ? moment(date).format('DD.MM.YYYY HH:mm:ss') : ''
    },

    onEventlogDateFromChange () {
      if (this.eventlogDateFrom > this.eventlogDateTo) {
        this.eventlogDateTo = this.eventlogDateFrom
      }
      this.onEventlogDateChange()
    },

    onEventlogDateToChange () {
      if (this.eventlogDateFrom > this.eventlogDateTo) {
        this.eventlogDateFrom = this.eventlogDateTo
      }
      this.onEventlogDateChange()
    },

    async onEventlogDateChange () {
      this.saveEventlogDatesOptions()
      await this.loadEventlog(
        {
          dateFrom: this.getDate(this.eventlogDateFrom),
          dateTo: this.getDate(this.eventlogDateTo),
          skip: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
          take: this.tableOptions.itemsPerPage
        }
      )
    },

    async reloadEventlog () {
      // this.saveTableOptions()
      try {
        this.startPageLoading()
        await this.loadEventlog({
          dateFrom: this.getDate(this.eventlogDateFrom),
          dateTo: this.getDate(this.eventlogDateTo),
          skip: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
          take: this.tableOptions.itemsPerPage
        })
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      } finally {
        this.stopPageLoading()
      }
    },

    saveEventlogDatesOptions () {
      this.userSettings.eventlogDateFrom = this.eventlogDateFrom
      this.userSettings.eventlogDateTo = this.eventlogDateTo
      this.setUserSettings()
    },

    restoreEventlogDatesOptions () {
      if (this.userSettings?.eventlogDateFrom) {
        this.eventlogDateFrom = this.userSettings.eventlogDateFrom
      } else {
        this.eventlogDateFrom = (new Date()).toISOString()
      }

      if (this.userSettings?.eventlogDateTo) {
        this.eventlogDateTo = this.userSettings.eventlogDateTo
      } else {
        this.eventlogDateTo = (new Date()).toISOString()
      }
    }
  },


  async created () {
    this.setPageTitle(this.$t('nav.eventlog'))
    this.restoreEventlogDatesOptions()

    try {
      this.startPageLoading()
      await this.loadUsers()
      await this.loadEventlog(
        {
          dateFrom: this.getDate(this.eventlogDateFrom),
          dateTo: this.getDate(this.eventlogDateTo),
          skip: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
          take: this.tableOptions.itemsPerPage
        }
      )
      this.eventlogLoaded = true
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    } finally {
      this.stopPageLoading()
    }
  }
}
</script>

<style scoped lang="scss">
  .refresh-btn-wrapper {
    position: relative;
    top: 5px;
  }
</style>
